/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * RHF bridge for the due-date modal inline calendar field.
 *
 * @file AssignmentDueDateModalField.jsx
 * @author Gladson Samuel S
 * @since 2.0.0
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import AssignmentDueDateField from './AssignmentDueDateField';

const AssignmentDueDateModalField = ({
  name,
  control,
  rules,
  minDate,
  maxDate,
  filterDate,
  placeholderText
}) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field }) => (
      <AssignmentDueDateField
        value={field.value}
        onChange={field.onChange}
        minDate={minDate}
        maxDate={maxDate}
        filterDate={filterDate}
        placeholderText={placeholderText}
      />
    )}
  />
);

AssignmentDueDateModalField.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  rules: PropTypes.object,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  filterDate: PropTypes.func,
  placeholderText: PropTypes.string
};

AssignmentDueDateModalField.defaultProps = {
  rules: undefined,
  minDate: null,
  maxDate: null,
  filterDate: null,
  placeholderText: 'mm/dd/yyyy'
};

export default AssignmentDueDateModalField;
